import styled from "styled-components";

export const ContactBoxWrapper = styled.div`
  max-width: 80rem;
  width: 100%;
  height: auto;
`;

export const ContactBoxTitle = styled.h1`
  padding: 0 4rem;
  color: #3fca89;
  font-family: "Aladin", cursive;
  font-weight: 700;
  margin-bottom: 2rem;
  & > span {
    font-size: 2.8rem;
  }
  & > i {
    margin-left: 1rem;
    color: #3fca89;
    font-size: 3rem;
  }
`;
